import { Component, effect, inject, input, signal } from '@angular/core';
import { of } from 'rxjs';

import { ApplicationFileService } from '../../../../../core/services';
import { ApplicationFileType } from '../../../../../core/enums';

@Component({
  selector: 'dbx-image',
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss',
  standalone: true,
  imports: [],
})
export class ImageComponent {
  id = input<string>('');
  fileType = input.required<ApplicationFileType>();
  height = input<number>(32);
  width = input<number>(32);

  fileService = inject(ApplicationFileService);

  readonly url = signal<string | null>(null);

  constructor() {
    effect(() => {
      (this.fileType() === ApplicationFileType.PartnerLogo
        ? this.fileService.downloadPartnerLogo(this.id())
        : of('')
      ).subscribe({ next: this.url.set });
    });
  }
}
